<template>
<div>
    <div v-show="display">
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'"> {{$t('form.categorie.quel_type_de_produit_avez_vous_achete')}} </h1>
        <sav-fold-card v-model="open" class="mt-4" :close-button="false" :can-open="canOpen"  :id="$options.name">
            <template v-slot:close>
                <span class="font-bold" v-if="selected">{{selected.label}}</span>
            </template>
            <template v-slot:open>
                <sav-spinner v-if="loading" :size="10" />
                <list-items v-if="data" :data-src="data" :callback="end" :id="$options.name"></list-items>
                <!-- Modal request -->
                <modal :name="'request-' + requestModalParams.libelle">
                    <sav-request-modal :displayName="requestModalParams.label" :libelle="requestModalParams.libelle" @close="hideRequestModal" />
                </modal>
                <button @click="displayRequestModal" class="block ml-auto mt-4 text-gray-900 font-light border border-gray-200 p-1.5 px-3 text-xs rounded-xl hover:bg-gray-100 duration-200">
                    <i class="fa-solid fa-circle-question mr-0.5"></i> {{requestModalParams.label}} {{$t('form.marque.introuvable')}}
                </button>
            </template>
        </sav-fold-card>
    </div>
    <div v-if="!display">
        <sav-spinner />
    </div>
</div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'category',
    extends: FormCardExtension,

    data() {
        return {
            display: false      
        }
    },

    methods: {
        async init() {
            this.loading = true

            // Get api data
            let response = await apiService.post('getgroup', {
                marque: this.$formTool.getFormData('brand').label
            })
            if (response.data.posts.post) {
                this.data = this.$imgGridTool.convert('group_name', 'img', response.data.posts.post)
            } else {
                this.data = []   
            }

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.nextBlock = await this.getNextBlock()
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            // if (this.data && this.data.length == 1) {
            //     this.end(this.data[0])
            //     this.$parent.hideBlockByName(this.$options.name)
            // } else {
                // this.display = true
            // }

            this.display = true

            // Set Modal Requests
            this.requestModalParams = {
                label: this.$t('form.categorie.categorie'),
                libelle: 'category'
            }

            this.loading = false
        },

        async end(callbackData) {
            this.$formTool.addFormData(this.$options.name, callbackData)
            this.nextBlock = await this.getNextBlock()
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }

            this.selected = JSON.parse(JSON.stringify(callbackData))

        },

        async getNextBlock() {
            let response = await apiService.post('getcateg', {
                id_group: this.$formTool.getFormData('category').id,
                marque: this.$formTool.getFormData('brand').label,
                // id_fam: this.getBlock('family').result ? this.getBlock('family').result.id : null
            })
            if (response.data.posts.post && response.data.posts.post.length > 0) {
                return this.$formTool.blockData(this.$options.name).next.subcategory
            }
            return this.$formTool.blockData(this.$options.name).next.device
        },
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/product/CategoryCard.vue